<section>
    <div class="bg-white p-6">

        <ng-container *ngIf="!warrantyAgreementOpen">
            <h1 class="typography-title-m m-0">
                {{'create-claim.warranty.complete_warranty_information' | translate}}
            </h1>
            <div class="divider mt-3 mb-8"></div>

            <div class="flex justify-center">
                <div class="max-w-[1000px] flex-1 flex flex-col gap-6">
                    <p class="m-0 typography-body-m-medium">
                        {{'create-claim.warranty.select_the_warranty' | translate}}
                    </p>
                    <div>
                        <label for="warrantySelect" class="typography-body-m-medium">
                            {{'create-claim.warranty.warranty' | translate}}
                        </label>
                        <div class="mt-2">
                            <app-select
                                id="warrantySelect"
                                [options]="warrantyOptions"
                                [selectedValue]="selectedWarranty"
                                [disabled]="isWarrantySelectorDisabled"
                                [isClearable]="false"
                                [placeholder]="'select' | translate"
                                (selectedValueChanged)="onWarrantySelected($event)"
                            ></app-select>
                        </div>
                    </div>
                    <div class="flex gap-6 flex-wrap">
                        <div class="flex-1 basis-full md:basis-0">
                            <label class="mb-2 block typography-body-m-medium">
                                {{'create-claim.warranty.client_name' | translate}}*
                            </label>
                            <div class="flex">
                                <input
                                    [disabled]="isExistingWarranty"
                                    class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                    type="text"
                                    [placeholder]="'create-claim.warranty.client_name' | translate"
                                    [(ngModel)]="claimInformation.warrantyData.homeOwnerFirstName"
                                    (ngModelChange)="onClaimWarrantyChange()"
                                >
                            </div>
                        </div>
                        <div class="flex-1 basis-full md:basis-0">
                            <label class="mb-2 block typography-body-m-medium">
                                {{'create-claim.warranty.client_last_name' | translate}}*
                            </label>
                            <div class="flex">
                                <input
                                    [disabled]="isExistingWarranty"
                                    class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                    type="text"
                                    [placeholder]="'create-claim.warranty.client_last_name' | translate"
                                    [(ngModel)]="claimInformation.warrantyData.homeOwnerLastName"
                                    (ngModelChange)="onClaimWarrantyChange()"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="flex gap-6 flex-wrap">
                        <div class="flex-1 basis-full md:basis-0">
                            <label class="mb-2 block typography-body-m-medium">
                                {{'create-claim.warranty.phone' | translate}}*
                            </label>
                            <div class="flex">
                                <input
                                    [disabled]="isExistingWarranty"
                                    class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                    type="text"
                                    [placeholder]="'create-claim.warranty.phone' | translate"
                                    [(ngModel)]="claimInformation.warrantyData.homeOwnerPhone"
                                    (ngModelChange)="onClaimWarrantyChange()"
                                >
                            </div>
                        </div>
                        <div class="flex-1 basis-full md:basis-0">
                            <label class="mb-2 block typography-body-m-medium">
                                {{'create-claim.warranty.email' | translate}}*
                            </label>
                            <div class="flex">
                                <input
                                    #emailInput="ngModel"
                                    [disabled]="isExistingWarranty"
                                    class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                    type="email"
                                    email
                                    [placeholder]="'create-claim.warranty.email' | translate"
                                    [(ngModel)]="claimInformation.warrantyData.homeOwnerEmail"
                                    (ngModelChange)="checkInput(emailInput.errors, 'emailErrors', true); onClaimWarrantyChange(emailInput.errors)"
                                    (focusout)="checkInput(emailInput.errors, 'emailErrors')"
                                />
                            </div>
                            <p *ngIf="formErrors.emailErrors" class="m-0 mt-2 typography-body-m-regular text-danger">
                                {{'create-claim.warranty.email_invalid' | translate }}
                            </p>
                        </div>
                    </div>
                    <div class="flex gap-6 flex-wrap">
                        <div class="flex-1 basis-full md:basis-0">
                            <label class="mb-2 block typography-body-m-medium">
                                {{'create-claim.warranty.address' | translate}}*
                            </label>
                            <div class="flex">
                                <input
                                    [disabled]="isExistingWarranty"
                                    class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                    type="text"
                                    [placeholder]="'create-claim.warranty.address' | translate"
                                    [(ngModel)]="claimInformation.warrantyData.homeOwnerStreet"
                                    (ngModelChange)="onClaimWarrantyChange()"
                                >
                            </div>
                        </div>
                        <div class="flex-1 basis-full md:basis-0">
                            <label class="mb-2 block typography-body-m-medium">
                                {{'create-claim.warranty.city' | translate}}*
                            </label>
                            <div class="flex">
                                <input
                                    [disabled]="isExistingWarranty"
                                    class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                    type="text"
                                    [placeholder]="'create-claim.warranty.city' | translate"
                                    [(ngModel)]="claimInformation.warrantyData.homeOwnerCity"
                                    (ngModelChange)="onClaimWarrantyChange()"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="flex gap-6 flex-wrap">
                        <div class="flex-1 basis-full md:basis-0">
                            <label class="mb-2 block typography-body-m-medium">
                                {{'create-claim.warranty.postal_code' | translate}}*
                            </label>
                            <div class="flex">
                                <input
                                    [disabled]="isExistingWarranty"
                                    class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                    type="text"
                                    [placeholder]="'create-claim.warranty.postal_code' | translate"
                                    [(ngModel)]="claimInformation.warrantyData.homeOwnerPostalCode"
                                    (ngModelChange)="onClaimWarrantyChange()"
                                >
                            </div>
                        </div>
                        <div class="flex-1 basis-full md:basis-0">
                            <label class="mb-2 block typography-body-m-medium">
                                {{'create-claim.warranty.state' | translate}}*
                            </label>
                            <div class="flex">
                                <input
                                    [disabled]="isExistingWarranty"
                                    class="input flex-1 py-2 px-4 typography-body-m-regular border border-border-secondary"
                                    type="text"
                                    [placeholder]="'create-claim.warranty.state' | translate"
                                    [(ngModel)]="claimInformation.warrantyData.homeOwnerState"
                                    (ngModelChange)="onClaimWarrantyChange()"
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="warrantyAgreementOpen">
            <h1 class="typography-title-m m-0">
                {{'create-claim.transfer_agreement' | translate}}
            </h1>
            <div class="divider mt-3 mb-8"></div>

            <div *ngIf="warrantyAgreementOpen" class="flex flex-col gap-6 p-0 md:px-6">
                <alert type="info">
                    <div>
                        <p class="m-0 typography-body-m-regular">
                            {{'my_displays.myclients_contactdata_rememberhint' | translate}}
                        </p>
                        <ul class="p-0">
                            <li class="typography-body-m-regular">
                                {{'create-claim.we_commit_to_take_care_of_client_data' | translate}}
                            </li>
                            <li class="typography-body-m-regular">
                                {{'create-claim.you_must_inform_your_client_that_you_are_going_to_transfer_their_data' | translate}}
                            </li>
                            <li class="typography-body-m-regular">
                                {{'create-claim.this_contract_will_always_be_available_to_you' | translate}}
                            </li>
                        </ul>
                    </div>
                </alert>
                <div class="flex justify-center m-0 md:mx-10">
                    <div class="scrollable h-[430px] w-full max-w-[600px] p-2 border border-dashed border-primary" style="background-color: #D2E1E8">
                        <iframe
                            [src]="warrantyAgreementUrl"
                            width="100%"
                            height="414"
                            frameborder="0"
                        ></iframe>
                    </div>
                </div>
                <div [ngClass]="{'invisible': !isWarrantyAgreementLoaded}" class="mt-4 col-span-12">
                    <label class="marginComponents flex items-center text-sm w-full">
                        <app-checkbox [checked]="isWarrantyAgreementSigned" (checkboxChange)="updateWarrantyAgreement($event)" class="mr-2" />
                        <span class="typography-body-m-regular">{{ 'my_sales.accept_terms_label' | translate }}</span>
                    </label>
                </div>
            </div>
        </ng-container>
    </div>
</section>